export const MESSAGES: Messages = {
  CREATE: {
    SUCCESS: {
      variant: "default",
      description: "Divergência criada com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao criar divergência.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  UPDATE: {
    SUCCESS: {
      variant: "default",
      description: "Divergências atualizadas com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao atualizar divergência.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  DISABLED: {
    SUCCESS: {
      variant: "default",
      description: "Operação realizada com sucesso na divergência!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao realizar a operação na divergência.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  INFOS_FILLED: {
    SUCCESS: {
      variant: "default",
      description: "Divergência preenchida com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Preencha todas as informações.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  NO_DATA_CHANGED: {
    ERROR: {
      variant: "destructive",
      description: "Preencha todas as informações.",
      duration: 5000,
      closeOnClick: true,
    },
    SUCCESS: {
      variant: "default",
      description: "Nenhum dado alterado.",
      duration: 5000,
      closeOnClick: true,
    }
  }
}

export const MESSAGES_NSU: Messages = {
  NSU_CREATE: {
    SUCCESS: {
      variant: "default",
      description: "NSU criado com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao criar NSU.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  NSU_UPDATE: {
    SUCCESS: {
      variant: "default",
      description: "NSUs atualizados com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao atualizar NSU.",
      duration: 5000,
      closeOnClick: true,
    },
  },
}